import { SceneState } from '../../../components/SceneStatemachinePlugin';
import { HUMALONG_VO } from '../config/config';

export class StateXylophoneSongPlay extends SceneState {
  constructor(scene, { character, xylophone, xylophoneBubbles }) {
    super(scene);
    this.character = character;
    this.xylophone = xylophone;
    this.xylophoneBubbles = xylophoneBubbles;
    this.bubbleOnNote = 6;
  }

  startState(songConfig) {
    this.songId = songConfig.id;
    this.songData = [...songConfig.data];
    this.notesPlayed = 0;
    this.scene.setDisplayType('play', { onComplete: this.startSong, onCompleteScope: this });
  }

  startSong() {
    this.scene.character.setTalking(true);
    this.scene.game.vo.play(HUMALONG_VO[`hum_${this.songId}`]);

    this.songPlaying = this.game.soundController.playSFXSound(`humalong_${this.songId}`);
    this.songPlaying.once('complete', this.handleSongComplete, this);

    this.characterAnimation = this.character.spine.setAnimation(0, 'humming', true, true);
    this.characterAnimationData = this.character.spine.findAnimation('humming');
    this.character.spine.timeScale = 0;
  }

  handleSongComplete() {
    this.scene.character.setTalking(false);
    this.character.play('humming_end', true, true);
    this.emit('state_complete');
  }

  onSceneUpdate(time, delta) {
    if (this.songPlaying?.isPlaying && this.songData.length) {
      const currentTime = this.songPlaying.getCurrentTime();
      while (this.songData[0]?.time <= currentTime) {
        this.songData[0].notes.forEach((note) => this.playNote(note));
        this.songData.shift();
      }

      const progress = currentTime / this.songPlaying.duration;
      this.characterAnimation.trackTime = this.characterAnimationData.duration * progress;
    }
  }

  playNote(note) {
    this.xylophone.playNote(note, 'interact');
    if (this.notesPlayed % this.bubbleOnNote == 0) this.xylophoneBubbles.spawnBubble(note);
    this.notesPlayed++;
  }

  endState() {
    if (this.character && this.character.spine) this.character.spine.timeScale = 1;
    if (this.songPlaying) {
      this.songPlaying.stop();
      this.songPlaying = null;
    }
  }
}
